import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  EAuthActions,
  GetPermissions,
  GetPermissionsFailure,
  GetPermissionsSuccess
} from '../actions/auth.actions';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { AuthService } from '@eview/core/auth';
import { Injectable, inject } from '@angular/core';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../states/app.state';
import { selectPermissionsLoaded } from '../selectors/catalog.selectors';

@Injectable()
export class PermissionsEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store<AppState>);
  private readonly authService = inject(AuthService);

  get$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetPermissions>(EAuthActions.GetPermissions),
      withLatestFrom(this.store.select(selectPermissionsLoaded)),
      filter(([action, loaded]) => action.force || !loaded),
      switchMap(() =>
        this.authService.permissions().pipe(
          map(payload => new GetPermissionsSuccess(payload)),
          catchError(() => of(new GetPermissionsFailure()))
        )
      )
    )
  );
}
